<template>
  <section class="appearance-settings">
    <h2 class="box__title">{{ $t('appearanceSettings.title') }}</h2>
    <p class="appearance-settings__description">
      {{ $t('appearanceSettings.description') }}
    </p>
    <RadioGroup
      :model-value="appearance"
      class="appearance-settings__options"
      :options="options"
      vertical-layout
      @update:model-value="setAppearance"
    />
  </section>
</template>

<script setup>
import { computed } from 'vue'

import RadioGroup from '@baserow/modules/core/components/RadioGroup.vue'
import { useAppearance } from '@baserow/modules/core/composables/useAppearance'

const { $i18n } = useNuxtApp()
const { appearance, setAppearance } = useAppearance()

const options = computed(() => [
  { value: 'light', label: $i18n.t('appearanceSettings.light') },
  { value: 'dark', label: $i18n.t('appearanceSettings.dark') },
  { value: 'system', label: $i18n.t('appearanceSettings.system') },
])
</script>
